module.exports = __webpack_public_path__ + "media/images/front/icon_popular_01-bf1cf80b012619b2dd4cb8c323360921.svg";